import { readFeature } from "@abaco/map-web-module/src/modules/map-web-module/LayerBuilder";
import { AxiosResponse, HTTPClient } from "@abaco/web-common/src/HTTP";
import { PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { Overview, Province } from "../models/Counts";

export default class CountsApi {
    [x: string]: any;
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    async downloadXls(campaign: number, pkCuaa: number, isDetailed: boolean): Promise<AxiosResponse<any, any>> {
        const url = `/fhc/api/v1/counting/farms/${pkCuaa}/campaigns/${campaign}?is_detailed=${isDetailed}`;
        const res = await this.http.get(url, { responseType: 'blob' });

        return res;
    }

    async getReferenceArea(subject: number, isSC: boolean, paging: PagingParams): Promise<PagedResults<any>> {
        const farmOrSc = isSC
            ? `?scs_subject_id=${subject}`
            : `?subject_id=${subject}`;

        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/dictionary_reference_area${farmOrSc}`, {
            params: {
                offset: 0, //paging.offset,
                count: 300 //2//paging.count,
            }
        });
        return res.data;
    }

    async getOverview(campaign: number, pkCuaa: number, province: Province | null = null, lotId: number | null = null): Promise<Overview[]> {
        const params = {
            province_id: province?.province_id,
            plot_id: lotId
        }
        const res = await this.http.get(`/sitiagri-rest-api/api/v1/dashboard/countings/subjects/${pkCuaa}/campaign/${campaign}/overview`, {params});
        return res.data;
    }

    async getActivities(campaign: number, subject: number, province: Province | null = null, lotId: number | null = null): Promise<any> {
        const params = {
            province_id: province?.province_id,
            plot_id: lotId
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/countings/subjects/${subject}/campaign/${campaign}/activities`, {params});
        return res.data;
    }

    async getCountings(campaign: number, subject: number, isSC = false, province: Province | null = null, type: "map" | "history" = "map", lotId: number | null = null) {
        const farmOrSc = isSC
            ? `scs`
            : `subjects`

        const params = {
            province_id: province?.province_id,
            plot_id: lotId
        }

        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/countings/${farmOrSc}/${subject}/campaign/${campaign}/${type}`, {params});
        return res.data;
    }

    async getMap(campaign: number, subject: number, isSC = false, province: Province | null, lotId: number | null = null): Promise<any> {
        return await this.getCountings(campaign, subject, isSC, province, "map", lotId);
    }

    async getHistory(campaign: number, subject: number, isSC = false, province: Province | null, lotId: number | null = null): Promise<any> {
        return await this.getCountings(campaign, subject, isSC, province, "history", lotId);
    }
}
